import { FormProvider, useForm, useWatch } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-hot-toast";
import { useEffect } from "react";
import {
  useCreatePIPMutation,
  useGetAppraisalObjectiveMainQuery,
  useGetCounsellingTypeListQuery,
  useGetDevelopmentTypeListQuery,
  useGetExpectedImprovementPlanQuery,
  useGetTrainingRequisitionQuery,
  useGetTrainingTypeQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  FormInput,
  FormSelect,
  FormTemplate,
} from "../../../../Components/Forms/InputTemplate";
export function PIPModal({
  isOpen,
  setIsOpen,
  isLoading,
  referenceId,
  appraiseeId,
  kraId,
  onValidate = () => {},
}) {
  const { data: objectives } = useGetAppraisalObjectiveMainQuery({
    PageNumber: 1,
    PageSize: 9999,
    ApprovalStatus: 0,
  });
  const { data: developmentPlan } = useGetDevelopmentTypeListQuery({
    Search: "",
    PageNumber: 1,
    PageSize: 9999,
    StartDate: "",
    EndDate: "",
    ApprovalStatus: 0,
  });
  const { data: improvementPlan } = useGetExpectedImprovementPlanQuery({
    Search: "",
    PageNumber: 1,
    PageSize: 9999,
    StartDate: "",
    EndDate: "",
    ApprovalStatus: 0,
  });
  const PIPType = [
    {
      key: 1,
      value: "Training",
    },
    {
      key: 2,
      value: "Counselling",
    },
  ];
  const TrainingMode = [
    {
      key: 1,
      value: "Online",
    },
    {
      key: 2,
      value: "Physical",
    },
  ];
  const categoryTypes = [
    {
      key: 0,
      value: "Behavioral",
    },
    {
      key: 1,
      value: "Technical",
    },
    {
      key: 2,
      value: "Managerial",
    },
  ];
  const [onCreate] = useCreatePIPMutation();
  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      pipType: "",
    },
  });
  const {
    handleSubmit,
    formState: { isValid },
    watch,
    control,
    setValue,
  } = formMethods;
  const watchCategory = watch("categoryId");
  const watchTrainingType = watch("trainingTypeid");
  const watchPipType = useWatch({ control, name: "pipType" });
  const { data: conselling } = useGetCounsellingTypeListQuery({
    PageSize: 1000,
    PageNumber: 1,
    ApprovalStatus: 0,
  });
  const {
    data: requisition
  } = useGetTrainingRequisitionQuery(
    {
      TraniningTypeId: watchTrainingType,
      PageSize: 1000,
      PageNumber: 1,
      ApprovalStatus: 0,
    },
    {
      skip: !watchTrainingType,
    }
  );
  const submit = async (data) => {
    const isTrainingLocal = parseInt(data.pipType) === 1;
    const hoursValue = isTrainingLocal
      ? parseInt(data.hours)
      : parseInt(data.counsellingHours);
    const payload = {
      referenceId,
      appraiseeId,
      kraId,
      developmentPlan: data.developmentPlan,
      engagementHours: hoursValue,
      targetImprovementPercent: parseInt(data.targetImprovementPercent),
      pipType: parseInt(data.pipType),
      trainingMode: isTrainingLocal ? parseInt(data.trainingMode) : undefined,
      pIPObjective: data.pIPObjective,
      expectedImprovement: data.expectedImprovement,
      supportTypeIds: isTrainingLocal
        ? (requisition?.responseObject?.pageItems || []).map((item) => item.id)
        : [parseInt(data?.counsellingTypes)],
      categoryId: isTrainingLocal ? parseInt(data.categoryId) : undefined,
    };
    try {
      const response = await onCreate(payload).unwrap();
      if (response?.successful) {
        toast.success(response?.statusMessage);
        onValidate();
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.data?.statusMessage);
    }
  };
  const { data: trainingType } = useGetTrainingTypeQuery({
    Category: watchCategory,
    PageSize: 1000,
    PageNumber: 1,
  });
  const trainingTypeList =
    trainingType?.result || trainingType?.responseObject?.pageItems || [];
  const counsellingTypeList =
    conselling?.responseObject?.pageItems || conselling?.result || [];

  const isTraining = watchPipType === "1" || watchPipType === 1;
  const isCounselling = watchPipType === "2" || watchPipType === 2;

  useEffect(() => {
    if (watchPipType) {
      // Clear type-specific fields when switching PIP types
      setValue("categoryId", "");
      setValue("trainingTypeid", "");
      setValue("trainingMode", "");
      setValue("hours", "");
      setValue("counsellingTypes", []);
      setValue("counsellingHours", "");
      setValue("startDate", "");
      setValue("endDate", "");
    }
  }, [watchPipType, setValue]);

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Setup</h4>
          <h1 className="text-[28px] font-[800]">PIP</h1>
          <p>Set measurable objectives aligned with the employee’s job role.</p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              {requisition?.successful === false && (
                <div className="my-3 flex justify-center items-center">
                  <p className="text-red-500">
                    {requisition?.statusMessage} for the selected training
                    category.
                  </p>
                </div>
              )}
              <FormSelect
                title={"PIP Objective"}
                camelCase={"pIPObjective"}
                placeholder={"select"}
                array={objectives?.result?.map((opt, index) => (
                  <option
                    key={index + 1}
                    value={`${opt?.title} ${opt?.designation?.designationName}`}
                  >
                    {opt?.title} {opt?.designation?.designationName}
                  </option>
                ))}
                defaultValue={""}
              />
              <FormSelect
                title={"PIP Type"}
                camelCase={"pipType"}
                placeholder={"select"}
                array={PIPType?.map((opt, index) => (
                  <option key={index + 1} value={opt.key}>
                    {opt.value}
                  </option>
                ))}
                defaultValue={0}
              />

              {/* Training PIP Fields */}
              {isTraining && (
                <>
                  <FormSelect
                    title={"Training Category"}
                    camelCase={"categoryId"}
                    placeholder={"select"}
                    array={categoryTypes.map((opt, index) => (
                      <option key={index + 1} value={opt.key}>
                        {opt.value}
                      </option>
                    ))}
                    defaultValue={0}
                  />
                  <FormSelect
                    title={"Training Types"}
                    camelCase={"trainingTypeid"}
                    placeholder={"select"}
                    array={trainingTypeList.map((opt, index) => (
                      <option key={index + 1} value={opt.uuId || opt.id}>
                        {opt.title || opt.name}
                      </option>
                    ))}
                    defaultValue={0}
                    disabled={trainingTypeList.length === 0}
                  />
                  <FormSelect
                    title={"Training Mode"}
                    camelCase={"trainingMode"}
                    placeholder={"select"}
                    array={TrainingMode?.map((opt, index) => (
                      <option key={index + 1} value={opt.key}>
                        {opt.value}
                      </option>
                    ))}
                    defaultValue={0}
                  />
                  <FormInput
                    title={"Hours"}
                    camelCase={"hours"}
                    placeholder={"e.g. 16"}
                    type="number"
                    min={1}
                  />
                </>
              )}

              {/* Counselling PIP Fields */}
              {isCounselling && (
                <>
                  <FormSelect
                    title={"Counselling Types"}
                    camelCase={"counsellingTypes"}
                    placeholder={"select"}
                    array={counsellingTypeList.map((opt, index) => (
                      <option key={index + 1} value={opt.id}>
                        {opt.name || opt.title}
                      </option>
                    ))}
                    defaultValue={0}
                  />
                  <FormInput
                    title={"Counselling Hours"}
                    camelCase={"counsellingHours"}
                    placeholder={"e.g. 8"}
                    type="number"
                    min={1}
                  />
                </>
              )}

              {/* Common/Additional Fields */}

              <FormSelect
                title={"Development Plan"}
                camelCase={"developmentPlan"}
                placeholder={"Describe the plan"}
                array={developmentPlan?.result?.map((opt, index) => (
                  <option key={index + 1} value={opt.title}>
                    {opt.title}
                  </option>
                ))}
                defaultValue={""}
              />

              <FormSelect
                title={"Expected Improvement"}
                camelCase={"expectedImprovement"}
                placeholder={"Describe expected improvement"}
                array={improvementPlan?.result?.map((opt, index) => (
                  <option key={index + 1} value={opt.title}>
                    {opt.title}
                  </option>
                ))}
                defaultValue={""}
              />
              <FormInput
                title={"Target Improvement Percent (%)"}
                camelCase={"targetImprovementPercent"}
                placeholder={"e.g. 20"}
                type={"number"}
                max={100}
              />

              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Create
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
}
